import React from "react";
import { Box, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { VideoCameraFront } from "@mui/icons-material";

const VideoPreview = ({
  preview,
  setPreview,
  formik,
  setGoalVideos,
  index,
  Admin_user_cond,
}) => {
  return (
    <>
      <Box className="video-preview-wrapper-goal">
        {Admin_user_cond ? null : (
          <IconButton
            onClick={() => {
              setPreview(null);
              setGoalVideos((prev) =>
                prev.map((data, i) => {
                  if (i == index) {
                    return { ...data, goal: null, checked: false };
                  } else {
                    return { ...data };
                  }
                }),
              );
            }}
            sx={{
              position: "absolute",
              top: "5px",
              right: "5px",
              color: "white",
              zIndex: "2",
              "&:hover": {
                color: "black",
                cursor: "pointer",
              },
            }}
          >
            <ClearIcon
              sx={{
                fontSize: "22px",
                color: "white",
                "&:hover": {
                  color: "black",
                  cursor: "pointer",
                },
              }}
            />
          </IconButton>
        )}
        <video
          width={"100%"}
          height={"100%"}
          className="video-preview"
          controls
          muted
          src={preview}
        />
      </Box>
    </>
  );
};

export default VideoPreview;
